// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d28cd441","239":"232fafd7","455":"22e7fec3"}[chunkId] + ".chunk.js";
};